import uuid from "uuid";

import * as types from './actionTypes';
import {clearCart, setJobId} from "./actionFunctions";
import {setReceiptUrl} from "./printFunctions";
import {setAmazonImageUrl} from "./serverFunctions";
import {setWizardSelectedValues} from "../visit/wizardLogic/wizardActions";
import {setWizardActiveStep, updateAllWizardValues} from "./wizardFunctions";
import {setActiveQuoteIndex, setQuotes} from "./roomsFunctions";

export const showOrderCompletePopup = (orderCompletePopupVisible) => ({
  type: types.SHOW_ORDER_COMPLETE_POPUP,
  payload: {orderCompletePopupVisible}
})

export const toggleShowMobileQuotes = (showMobileQuotes) => ({
  type: types.TOGGLE_SHOW_MOBILE_QUOTES,
  payload: {showMobileQuotes}
})

export const toggleShowAllQuotesCartItemsList = (showAllQuotesCartItemsList) => ({
  type: types.TOGGLE_SHOW_ALL_QUOTES_CART_ITEMS_LIST,
  payload: {showAllQuotesCartItemsList}
})

export const getMinimumChargeCartItem = (fromCartItem, onlyMinimum = false, quantity = 1) => {
  const {selectionGroup, partId, currentQuote, } = fromCartItem;
  const newDbFeature = Object.assign({}, fromCartItem.cartFeature.dbFeature, {
    id: 1,
    customDisplayName: "additionalCartItem.minimumCharge",
    displayName: "additionalCartItem.minimumCharge",
    sharedFeatureName: "additionalCartItem.minimumCharge",
  });
  if (onlyMinimum) {
    newDbFeature.cost = 375;
    newDbFeature.costplus = 375;
    newDbFeature.stonePricingId = null;
  }
  let minCartItem = {
    id: uuid.v4(),
    isEmpty: false,
    isMinimumCharge: true,
    isMinimumChargeItems: !onlyMinimum,
    selectionGroup,
    partId,
    currentQuote,
    quantity,
    cartFeature: Object.assign({}, fromCartItem.cartFeature, {
      fromFeatureName: fromCartItem.cartFeature.getFeatureName(),
      partName: "additionalCartItem.minimumCharge",
      _customDisplayName: "additionalCartItem.minimumCharge",
      _countertopGroupsCustomDisplayName: "additionalCartItem.minimumCharge",
      metaData: {},
      notesList: {},
      getCountertopGroupsSplittedFeatureName: function () {
        return this.partName
      },
      getSplittedFeatureName: function () {
        return this.partName
      },
      getFeatureName: function () {
        return this.partName
      },
      dbFeature: newDbFeature,
    })
  }
  if (fromCartItem.fromWizardId || minCartItem.fromWizardGroupId) { // just in case fromWizardId is 0
    minCartItem.fromWizardId = fromCartItem.fromWizardId; // this is needed to prevent showing minimum cart item ↓
    minCartItem.fromWizardStep = fromCartItem.fromWizardStep; // in different wizards in advanced quoting ↓
    minCartItem.fromWizardGroupId = fromCartItem.fromWizardGroupId; // for the same groups
  }
  return minCartItem
};

export const setCartFooterActiveButtonIndex = (cartFooterActiveButtonIndex) => ({
  type: types.SET_CART_FOOTER_ACTIVE_BUTTON_INDEX,
  payload: {cartFooterActiveButtonIndex}
})

export const setCartItemEditFeature = (cartItemEditFeature) => ({
  type: types.SET_CART_ITEM_EDIT_FEATURE,
  payload: {cartItemEditFeature}
})

export const setLookRemovedCartItems = (lookRemovedCartItems) => ({
  type: types.SET_LOOK_REMOVED_CART_ITEMS,
  payload: {lookRemovedCartItems}
})

export const setCItemsAddedToParentCart = (cartItems) => ({
  type: types.SET_CART_ITEMS_ADDED_TO_PARENT_CART,
  payload: {cartItems}
})

export const changeAllCartItems = (cartItems) => ({
  type: types.CHANGE_ALL_CART_ITEMS,
  payload: {cartItems}
})

export const setSureTax = (sureTax) => ({
  type: types.SET_SURE_TAX,
  payload: {sureTax}
});
export const setSureTaxLoading = (sureTaxLoading) => ({
  type: types.SET_SURE_TAX_LOADING,
  payload: {sureTaxLoading}
});
export const setDeliveryList = (deliveryList) => ({
  type: types.SET_DELIVERY_LIST,
  payload: {deliveryList}
});

export const clearCartAndStartOver = (fullClear = false) => {
  return (dispatch) => {
    if (fullClear) {
      dispatch(setWizardSelectedValues({}, true));
      dispatch(setWizardActiveStep(0));
      dispatch(updateAllWizardValues([]));
      dispatch(setActiveQuoteIndex(0));
      dispatch(setQuotes([{}]));
    }
    dispatch(clearCart()); // clear cart
    dispatch(setReceiptUrl("")); // clear receipt
    dispatch(setAmazonImageUrl("")); // not sure if it is needed here, but let it be
    dispatch(setJobId(0)); // erase current job
    document.kvConfig.jobId = null; // erase current job
  }
};

export const setManualTax = (manualTax) => ({
  type: types.SET_MANUAL_TAX,
  payload: {manualTax}
});

export const setMarkUpLogic = (markUpLogic) => ({
  type: types.SET_MARK_UP_LOGIC,
  payload: {markUpLogic}
});

